var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAccount(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "16px",
    viewBox: "0 0 14 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "669649C6-5582-4F7C-AC3C-2F146DBD6B9C") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logged-in---desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "D/home_incomplete",
    transform: "translate(-29.000000, -196.000000)",
    stroke: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "profile",
    transform: "translate(30.000000, 195.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path",
    transform: "translate(0.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.80700228,0.506215674 C6.70284416,0.50146497 7.39876707,0.776072117 7.90930544,1.28661049 C8.36976274,1.74706779 8.6456851,2.35742792 8.68970026,3.0029182 C8.69445096,3.89876009 8.41984381,4.594683 7.90930544,5.10522137 C7.44884814,5.56567867 6.83848801,5.84160103 6.19299772,5.88561618 C5.29715584,5.89036689 4.60123293,5.61575974 4.09069456,5.10522137 C3.63023726,4.64476407 3.3543149,4.03440394 3.31029974,3.38891365 C3.30554904,2.49307177 3.58015619,1.79714886 4.09069456,1.28661049 C4.55115186,0.826153188 5.16151199,0.550230827 5.80700228,0.506215674 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,16 L12,13.9513465 C12,10.772 9.3137085,8.19463035 6,8.19463035 C2.6862915,8.19463035 0,10.772 0,13.9513465 L0,16"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccount);
export default __webpack_public_path__ + "static/media/account.1fae8a7be39d1efc5f6576d981bdcff4.svg";
export { ForwardRef as ReactComponent };